module.exports = __webpack_public_path__ + "static/media/IconTemplates_-65.dbe891e3.svg";